module.exports = __webpack_public_path__ + "static/media/watersports_hp.5942c678.jpg";